export class ClientBankConnectionInfoModel {
  id: number;
  label: string;
  owner: string;
  iban: string;
  bic: string;
  bankName: string;
}
